/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {startTimecardBreak} from '../api'

export const useMutationStartTimecardBreak = createReactQueryMutationHook('startTimecardBreak', startTimecardBreak)
